// extracted by mini-css-extract-plugin
export default {"filter-control":"FilterControl_filter-control__QAqQU","input-wrapper":"FilterControl_input-wrapper__1o4yn","icon":"FilterControl_icon__Izcgk"};